import React from "react";
import { useTranslation } from "react-i18next";
import { Form, FormTextInput, isMandatory } from "@/shared/coralreef";
import type { FormState } from "@/shared/coralreef/components/Form/types";
import { AccountIdentity } from "./AccountIdentity";
import { LinkButton } from "./LinkButton";
import { DifferentEmailLink } from "./SavedAccountLinks";
import { LinkRow, Screen, ScreenTitle } from "./Screen";

export interface SavedAccountPasswordProps {
  email: string;
  online: boolean;
  onSubmit(password: string): void;
  onForgotPassword(): void;
  onDifferentEmail(): void;
}

export const SavedAccountPassword: React.FC<SavedAccountPasswordProps> = ({
  email,
  online,
  onSubmit,
  onForgotPassword,
  onDifferentEmail,
}) => {
  const { t } = useTranslation();
  const onSubmitHandler = ({ password }: FormState) => {
    onSubmit(password.value);
  };

  return (
    <Screen testId="login-saved-account-password" offline={!online}>
      <ScreenTitle>{t("Enter your password")}</ScreenTitle>
      <div className="flex items-center gap-2.5 p-2 rounded-[5px] border border-solid border-observe bg-observe-dark">
        <AccountIdentity email={email} />
      </div>
      <Form
        onSubmit={onSubmitHandler}
        submitButtonText={t("Log in")}
        submitButtonIsDisabled={!online}
      >
        <FormTextInput
          name="password"
          password
          label={t("Password")}
          validators={[isMandatory]}
        />
        <LinkRow>
          <DifferentEmailLink online={online} onClick={onDifferentEmail} />
          <LinkButton onClick={onForgotPassword}>
            {t("Forgot password?")}
          </LinkButton>
        </LinkRow>
      </Form>
    </Screen>
  );
};
